import type { Goal } from '@jungles/shared';

/** Existing onboarding choices; the goal affects workout templates, not a kcal formula. */
export const GOAL_OPTIONS: { id: Goal; hint: string; icon: string }[] = [
  { id: 'maintain', hint: 'Регулярно двигаться и держать вес', icon: '/assets/exercises/planka-na-predplechyakh.webp' },
  { id: 'mass', hint: 'Прогрессия весов и профицит калорий', icon: '/assets/exercises/zhim-shtangi-lezha.webp' },
  { id: 'cut', hint: 'Больше объёма и умеренный дефицит', icon: '/assets/exercises/podem-koleney-v-vise.webp' },
];
